import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface ResendConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  resendType: 'lab' | 'imaging' | null;
}

export const ResendConfirmDialog: React.FC<ResendConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  resendType,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle>Confirm Resend</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to resend this order to{' '}
          {resendType === 'lab' ? 'the lab' : 'the imaging center'}?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>No</Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 